import NewStoreLocation from './NewStoreLocation';

export default NewStoreLocation;
